import getFetchOptions from 'utils/getFetchOptions';

import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

export default function getFeideTwoSchools() {
	return fetch(
		`${ENDPOINT_URL}/getfeidetwoschools`,
		getFetchOptions({
			method: 'GET',
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
